import { createSlice } from "@reduxjs/toolkit";

const getAllClassSubjectMappingSlice = createSlice({
  name: "ClassSubjectMapping",
  initialState: {
    classSubjectMappingList : [],
    loading: false,
    error: null,
  },
  reducers: {
    getAllClassSubjectMappingRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getAllClassSubjectMappingSuccess: (state, action) => {
      state.loading = false;
      state.classSubjectMappingList = action.payload;
    },
   getAllClassSubjectMappingFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearAllClassSubjectMapping: (state) => {
      state.classSubjectMappingList = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getAllClassSubjectMappingRequest,
  getAllClassSubjectMappingSuccess,
  getAllClassSubjectMappingFailure,
  clearAllClassSubjectMapping,
} = getAllClassSubjectMappingSlice.actions;

export default getAllClassSubjectMappingSlice.reducer;
